import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'// 引用axios

// 按需引入element ui
// import 'element-ui/lib/theme-chalk/index.css' // css样式还是需要全部引入
// import element from './assets/js/element_ui'
// Vue.use(element)

// 完整引入element ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import global from './assets/js/global.js';
axios.defaults.baseURL = global.baseURL;

// 请求头配置
axios.interceptors.request.use(config => {
  // NProgress.start()
  config.headers.Authorization = global.getCookie('token')
  return config 
})
axios.interceptors.response.use(config =>{
  // NProgress.done() 
  if(config.data.code == 403){
    global.delCookie('token')
    global.delCookie('activePath')
    router.push('/login')
  }
  return config
})
//全局定义一个格式化时间的过滤器  dateFormat
Vue.filter('dateFormat', function(originVal,type) {
  if(!originVal)return ''
  const dt = new Date(originVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')
  if(type == 'day'){
    return `${y}-${m}-${d}`
  }else{
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
  }
})
Vue.config.productionTip = false
// 完整引入element ui
Vue.use(ElementUI);
Vue.prototype.$http = axios
Vue.prototype.$global = global

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
